import { useMutation, useQueryClient } from "@tanstack/react-query";
import { assignWizardConnections } from ".";
import { queryKeys } from "@/lib/useQuery/queryKeys";

export function useAssignWizardConnections() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ["connection","wizard"],
        mutationFn: assignWizardConnections,
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: queryKeys.crm._def, exact: false});
            queryClient.invalidateQueries({queryKey: queryKeys.crm_project._def, exact: false});
            queryClient.invalidateQueries({queryKey: queryKeys.crm_config._def, exact: false});
            queryClient.invalidateQueries({queryKey: queryKeys.project._def, exact: false});
            queryClient.invalidateQueries({queryKey: queryKeys.survey._def, exact: false});
        }
    });
}
